var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBtnArrowRigth(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_349_1872)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 15,
    r: 15,
    fill: "#096784"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.54 14.29L16.88 8.64004C16.787 8.54631 16.6764 8.47191 16.5546 8.42115C16.4327 8.37038 16.302 8.34424 16.17 8.34424C16.038 8.34424 15.9073 8.37038 15.7854 8.42115C15.6636 8.47191 15.553 8.54631 15.46 8.64004C15.2738 8.8274 15.1692 9.08085 15.1692 9.34504C15.1692 9.60922 15.2738 9.86267 15.46 10.05L20.41 15.05L15.46 20C15.2738 20.1874 15.1692 20.4409 15.1692 20.705C15.1692 20.9692 15.2738 21.2227 15.46 21.41C15.5526 21.5045 15.6631 21.5797 15.7849 21.6312C15.9068 21.6827 16.0377 21.7095 16.17 21.71C16.3023 21.7095 16.4332 21.6827 16.5551 21.6312C16.677 21.5797 16.7874 21.5045 16.88 21.41L22.54 15.76C22.6415 15.6664 22.7225 15.5527 22.7779 15.4262C22.8333 15.2997 22.8619 15.1631 22.8619 15.025C22.8619 14.8869 22.8333 14.7503 22.7779 14.6238C22.7225 14.4973 22.6415 14.3837 22.54 14.29Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_349_1872",
    x: 0,
    y: 0,
    width: 38,
    height: 38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.168627 0 0 0 0 0.176471 0 0 0 0 0.227451 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_349_1872"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_349_1872",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnArrowRigth);
export default __webpack_public_path__ + "static/media/btn-arrow-rigth.436793843e913b4e78d30bf17abf6821.svg";
export { ForwardRef as ReactComponent };